import { z } from "zod";
import { ValidationMessageKey } from "./validationMessages";

// More fields do exist on the response, we just don't care
// about them (at time of writing this).
// Created from https://<mtbe>/v2/<instanceID>/data-registry/categories/<uuid>/view
export const ResourceLibraryCategoryViewResponse = z.object({
  id: z.number(),
  registry_category_matrix_id: z.string(),
  name: z.string(),
});
export type ResourceLibraryCategoryViewResponse = z.infer<
  typeof ResourceLibraryCategoryViewResponse
>;

// Created from https://<mtbe>/v2/<instanceID>/data-registry/items/<numericProductId>
export const ResourceLibraryItemViewResponse = z.object({
  id: z.number(),
  registry_item_matrix_id: z.string(),
  registry_category_id: z.string(),
  registry_category_pk_id: z.number(),
  name: z.string(),
  display_id: z.string(),
  description: z.string().nullish(),
  version: z.number(),
  minor_version: z.number(),
  registry_category_version: z.number(),
  registry_category_minor_version: z.number(),
});
export type ResourceLibraryItemViewResponse = z.infer<
  typeof ResourceLibraryItemViewResponse
>;

export const ResourceLibraryItemCreationPayload = z.object({
  displayId: z
    .string()
    .nonempty(ValidationMessageKey.nonEmpty)
    .max(100, ValidationMessageKey.maxLength100),
  name: z
    .string()
    .nonempty(ValidationMessageKey.nonEmpty)
    .max(100, ValidationMessageKey.maxLength100),
});
export type ResourceLibraryItemCreationPayload = z.infer<
  typeof ResourceLibraryItemCreationPayload
>;

export const ResourceLibraryItemCreationResponse = z.object({ id: z.number() });
export type ResourceLibraryItemCreationResponse = z.infer<
  typeof ResourceLibraryItemCreationResponse
>;
